import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DashboardImage from "../images/DashboardImage.svg";
import CrossIcon from "../images/clearTextIcon.svg";
import ModuleStepper from "../components/ContentModules/ModuleWindow/ModuleStepper";
import ModuleContent from "../components/ContentModules/ModuleWindow/ModuleContent";
import { Button, Modal } from "react-bootstrap";
import CannotExitImage from "../images/Cannotexist.svg";
import BlueCheckBox from "../images/bluecheckbox.svg";
import MustExist from "../images/MustExist.svg";
import {
  searchForDetails,
  cloneTemplateApi,
  sendModuleCardtoEditor,
  getSharedFileFromTemp,
  getIndicationDetails,
  getModuleCardDetails
} from "../services/apis";
import CircularProgressBar from "../utils/CircularProgressBar";
import { showErrorToast, showSuccessToast } from "../components/toastComponent/ToastComponent";
  import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import ValueContext from "../utils/contextAPI/contextAPI";
import consolidateData from "../components/RunValidationCheck/ConsolidateData";
import { updateModuleCardsinEditor } from "../services/apis";

const ModuleSelectionPage = () => {
  const appData = useContext(ValueContext);
  const [closeTootltipTitle, setCloseTootltipTitle] = useState(false);
  const [activeStep, setActiveState] = useState(0);
  const [selectedModuleIds, setSelectedModuleIds] = useState([]);
  const [switchCustomJs, setSwitchCustomJs] = useState(false);
  const [moduleDetails, setModuleDetails] = useState([]);
  const [activeNextButton, setActiveNextButton] = useState(false);
  const [basicDetail, setBasicDetail] = useState();
  const [goTotemplate, setGoToTemplate] = useState(false);
  const [payloadData, setPayloadData] = useState({});
  const [modulesSelected, setModulesSelected] = useState([]);
  const [isloading, setIsloading] = useState(false);
  const [isOneTimeContent, setIsOneTimeContent] = useState(false);
  const navigate = useNavigate();

  const [steps, setSteps] = useState(['Import Module', 'Select Template', 'Author e-Detail', 'Generate RSD', 'Publish']);
  
  useEffect(() => {
    if(basicDetail?.tags?.includes("ONE_TIME_CONTENT") ) {
      setSteps(previousValue => previousValue.slice(1));
      setSwitchCustomJs(false);
      setGoToTemplate(true);
      setIsOneTimeContent(true);
    }
  }, [basicDetail?.brand.id]);

  useEffect(() => {
    setBasicDetail(JSON.parse(localStorage.getItem("basicEdetailData")));
  }, []);

  const nextHandler = () => {
    setSwitchCustomJs(false);
    setGoToTemplate(true);
    setActiveState(1);
  };

  const navigateToEditor = (pageId, data) => {
    if (pageId) {
      navigate(`/editor/${pageId}`, { state: { data: data }, replace: true });

      //appData.setDeckId(data);
    }
  };

   const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.white,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }));

  const createEdetailhandler = () => {
    setIsloading(true);
    const templatePayload =  isOneTimeContent ? { ...payloadData , tags: ["ONE_TIME_CONTENT"]} : { ...payloadData };
    templatePayload.pinch_to_zoom = basicDetail?.pinch_to_zoom
    delete templatePayload.id;
    let veevaArr = [];
    modulesSelected.forEach((vModule) => {
      let newObject = {
        moduleid: vModule?.moduleDamId,
        module_name: vModule?.moduleDamName,
        content_module_response: {
          moduleDamId: vModule?.moduleDamId,
          moduleDamName: vModule?.moduleDamName,
          countryName:vModule.countryName,
          productName:vModule.productName,
          moduleBusinessRules: vModule?.moduleBusinessRules,
          moduleName: vModule?.moduleName,
          id:vModule?.id
        }
      };
      veevaArr.push(newObject);
    });
    
    const metaPayload = {
      deckid: "",
      search_expression: {
        brand_name: basicDetail?.brand?.name,
        claim_category: "",
        name: "",
        module_name: [],
        asset_name: [],
        core_claim: [],
      },
      content_modules: veevaArr,
      module_type: "NEXT",
    };
    //get the list of module ids to consider for must use validation
    const moduleList_id = [
      ...new Set(
        (metaPayload?.content_modules ?? []).flatMap((m) => [
          m.content_module_response?.id,
          ...(m.content_module_response?.moduleBusinessRules?.map(
            (rule) => rule.targetModuleId
          ) ?? [])
        ])
      )
    ];
    //
    cloneTemplateApi(
      payloadData.id,
      templatePayload,
      (response, err, errorCode) => {
        if (err) {
          setIsloading(true);
          if (errorCode === 400) {
            showErrorToast(err?.response.data.err.message);
          } else
            showErrorToast('e-Detail Creation failed');
        } else {
          const returnedResponse = response.data?.response;
          showSuccessToast('Edetail Created Successfully');
          appData.setDeckId(returnedResponse);
          metaPayload.deckid = returnedResponse?._id;
          transferOwnerOfSharedResources(returnedResponse?._id, payloadData.id);
          moduleCreation(metaPayload, returnedResponse);
          
          /* commenting out must use validation for now
          mustUseValidationDatastored(moduleList_id, returnedResponse?._id); */
        }
      }
    );
  };

  const moduleCreation = (metaPayload, returnedResponse) => {
    sendModuleCardtoEditor(metaPayload, (response, err, errorCode) => {
      setIsloading(true);
      if (err) {
        if (errorCode === 400) {
          showErrorToast(err?.response.data.err.message);
        } else
          showErrorToast('e-Detail creation failed');
      } else {
        setIsloading(false);
        navigateToEditor(returnedResponse.slides[0].slideid, returnedResponse);

        localStorage.removeItem("basicEdetailData");
      }
    });
  };

  const transferOwnerOfSharedResources = async (edetailId, templateId) => {
    const payload = { deckId: edetailId, templateId: templateId };
    await getSharedFileFromTemp(payload, (response, err, ErrorCode) => {
      if (err) {
        if (ErrorCode === 400) {
          showErrorToast(err?.response.data.err.message);
        }
      } else {
      }
    });
  };

  const mustUseValidationDatastored = async(idList, deckid) => {
    try {
      const apiCalls = idList.map(
        (moduleID) =>
          new Promise((resolve, reject) => {
            getModuleCardDetails(
              moduleID,
              (response, err) => {
                if (err) reject(err);
                else {
                  const data = response.data;
                  resolve([
                    ...consolidateData(
                      data.claims,
                      data.moduleDamName,
                      "claims",
                    ),
                    ...consolidateData(
                      data.reusableTexts,
                      data.moduleDamName,
                      "reusableTexts",
                    ),
                     ...consolidateData(
                      data.components,
                      data.moduleDamName,
                      "components",
                    ),
                  ]);
                }
              },
              "linkedModulesType",
            );
          }),
      );

      const results = await Promise.all(apiCalls);
      const finalResult = results.flat();
      console.log("inputs", finalResult);
      const consolidateExisting = (...arrays) => {
        const map = new Map();

        arrays.flat().forEach((item) => {
          if (!item || !item.id) return;

          const existing = map.get(item.id);

          if (!existing) {
            map.set(item.id, { ...item });
          } else {
            map.set(item.id, {
              ...existing,
              ...item,
              used: existing.used || item.used,
            });
          }
        });

        return Array.from(map.values());
      };
      const payload = {
        selected_module_data: consolidateExisting(
          finalResult
        ),
      };
      appData.setDeckId({
        ...appData.deckId,
        selected_module_data: consolidateExisting(finalResult),
        from:'module_page'
      });
      await updateModuleCardsinEditor(
        deckid,
        payload,
        (response, err, errorCode) => {
          if (err) {
          } else {
            setIsloading(false);
          }
        },
      );
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {isloading && (
        <CircularProgressBar
          isloading={isloading}
          setIsloading={setIsloading}
        />
      )}
      <div className="module-modal">
        <div className="module-content-header">
          <div className="module-content-dashboard">
            <div className="d-flex align-items-center module-content-dashboard-header">
              <div className="module-content-dashboard-image">
                <img
                  src={DashboardImage}
                  alt=""
                  onClick={() =>
                    navigate("/", {
                      replace: true,
                    })
                  }
                />
              </div>
              <div className="module-content-dashboard-title">
                <h4>Create e-Detail</h4>
                <h2>
                  {basicDetail?.edetailName?.length > 14 ? (
                  <LightTooltip
                    className="mlrToolTip"
                    title={basicDetail?.edetailName}
                    arrow
                  >
                    <span>{basicDetail?.edetailName}</span>
                  </LightTooltip>
                ):(basicDetail?.edetailName)}
                  </h2>
              </div>
            </div>
            <div className="module-content-modal-promomats">
              <h4 className="module-content-modal-promomats-source">Source</h4>
              <strong className="module-content-modal-promomats-title">
                PromoMats
              </strong>
            </div>
            {closeTootltipTitle && (
              <div className="d-flex module-content-tooltip">
                <p>
                  Associated module(s) from other topics have been added based
                  on defined business rule(s)
                </p>
                <img
                  src={CrossIcon}
                  alt=""
                  width={18}
                  height={18}
                  className="img-fluid"
                />
                <div className="tooltip-arrow"></div>
              </div>
            )}
          </div>
        </div>
        <ModuleStepper activeStep={activeStep} steps={steps} />
        <div className="m-0 p-0 module-modal-body">
          <ModuleContent
            selectedModuleIds={selectedModuleIds}
            setSelectedModuleIds={setSelectedModuleIds}
            setActiveNextButton={setActiveNextButton}
            switchCustomJs={switchCustomJs}
            setSwitchCustomJs={setSwitchCustomJs}
            moduleDetails={moduleDetails}
            setModuleDetails={setModuleDetails}
            brands={basicDetail?.brand}
            basicDetail={basicDetail}
            market={basicDetail?.market}
            from="creation"
            modulePage={goTotemplate}
            setPayloadData={setPayloadData}
            payloadData={payloadData}
            setModulesSelected={setModulesSelected}
            modulesSelected={modulesSelected}
            isOneTimeContent={isOneTimeContent}
          />
        </div>
        {!goTotemplate && (
          <div className="module-modal-footer" style={{ padding: "0px 20px" }}>
            <div className="d-flex align-items-center" style={{ gap: "20px" }}>
              {!switchCustomJs && <>
              <div className="d-flex align-items-center">
                <img
                  src={BlueCheckBox}
                  alt="image"
                  className="module-modal-footer-image"
                />
                <h3 className="module-modal-footer-text">Selected Module</h3>
              </div>
              <div className="d-flex align-items-center">
                <img
                  src={CannotExitImage}
                  alt="image"
                  className="module-modal-footer-image"
                />
                <h3 className="module-modal-footer-text">Cannot exist with</h3>
              </div>
              <div className="d-flex align-items-center">
                <img
                  src={MustExist}
                  alt="image"
                  className="module-modal-footer-image"
                />
                <h3 className="module-modal-footer-text">
                  Must use or Related (Optional)
                </h3>
              </div>
              </>}
            </div>
            <div>
              <Button
                variant=""
                className="module-modal-footer-cancel"
                onClick={() => {
                  navigate("/");
                }}
              >
                CANCEL
              </Button>
              <Button
                variant=""
                className={`module-modal-footer-next ${
                  activeNextButton
                    ? "module-modal-footer-next-active"
                    : "module-modal-footer-next-deactive"
                }`}
                disabled={!activeNextButton}
                onClick={nextHandler}
              >
                NEXT
              </Button>
            </div>
          </div>
        )}
        {( goTotemplate && !isOneTimeContent ) && (
          <div className="module-modal-footer" style={{ padding: "0px 20px" }}>
            <Button
              variant=""
              className="module-modal-footer-cancel"
              onClick={() => {
                setGoToTemplate(false);
                setActiveState(0);
              }}
            >
              Back
            </Button>
            <Button
              variant=""
              className={`module-modal-footer-next ${
                payloadData.hasOwnProperty("id")
                  ? "module-modal-footer-next-active"
                  : "module-modal-footer-next-deactive"
              }`}
              disabled={!payloadData.hasOwnProperty("id")}
              onClick={createEdetailhandler}
            >
              NEXT
            </Button>
          </div>
        )}
        {( goTotemplate && isOneTimeContent ) && (
          <div className="module-modal-footer" style={{ padding: "0px 20px" }}>
            <Button
              variant=""
              className="module-modal-footer-cancel"
              onClick={() => {
                navigate("/");
              }}
            >
              CANCEL
            </Button>
            <Button
              variant=""
              className={`module-modal-footer-next ${
                payloadData.hasOwnProperty("id")
                  ? "module-modal-footer-next-active"
                  : "module-modal-footer-next-deactive"
              }`}
              disabled={!payloadData.hasOwnProperty("id")}
              onClick={createEdetailhandler}
            >
              NEXT
            </Button>
          </div>
        )}
      </div>
    </>
  );
};

export default ModuleSelectionPage;
